import tw from "tailwind-styled-components";

// Product Skeleton Loading Component
export const ProductLoading = ({ count = 16 }) => (
  <Grid>
    {[...Array(count)].map((_, index) => (
      <Card key={index}>
        <Image />
        <div className="w-full text-left flex flex-col flex-grow py-2">
          <div className="flex justify-between items-start gap-2 w-full">
            <div className="flex-grow space-y-2">
              <Name />
              <Brand />
            </div>
            <Button />
          </div>
          <Description />
          <Price />
        </div>
      </Card>
    ))}
  </Grid>
);

// Styled Components
const Grid = tw.div`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4 p-4`;
const Card = tw.div`animate-pulse flex flex-col items-center shadow-sm border border-gray-100 p-2 rounded-lg`;
const Image = tw.div`bg-gray-200 aspect-square w-full`;
const Name = tw.div`bg-gray-200 h-4 rounded w-5/6`; 
const Brand = tw.div`bg-gray-200 h-3 rounded w-1/2`;
const Description = tw.div`bg-gray-200 h-3 rounded w-full mt-2 mb-2`;
const Price = tw.div`bg-gray-200 h-5 rounded w-1/3 mt-2`;
const Button = tw.div`bg-gray-200 h-6 w-12 flex-shrink-0`;
